import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Select } from '@gpstrackit/gtc-react-controls';
import { useRealtimeUnits } from 'Core/hooks';

const VehicleFilter = ({ value, onChange }) => {
  const { messages } = useIntl();
  const maintenanceVehicles = useSelector(
    (state) => state.maintenanceVehiclesTabRedux.vehicles || []
  );

  const unitsResult = useRealtimeUnits({ trackFields: ['id', 'label', 'show'] });
  const units = React.useMemo(() => {
    let unitList = [];
    unitsResult.forEach((unit) => {
      if (unit.id !== -1 && unit.show !== 0) {
        unitList.push(unit);
      }
    });
    return unitList;
  }, [unitsResult]);

  const options = React.useMemo(() => {
    const mergedUnits = [...units];
    const unitIds = new Set(
      units
        .filter((unit) => unit?.id !== undefined && unit?.id !== null)
        .map((unit) => unit.id.toString())
    );

    maintenanceVehicles.forEach((unit) => {
      if (unit?.id === undefined || unit?.id === null) return;
      const id = unit.id.toString();
      if (!unitIds.has(id)) {
        unitIds.add(id);
        mergedUnits.push({
          id: unit.id,
          label: unit?.label || id,
          show: 1,
        });
      }
    });

    return mergedUnits.sort((a, b) => {
      const av = a?.label?.toString().toLowerCase().trim() || "";
      const bv = b?.label?.toString().toLowerCase().trim() || "";
      if (av < bv) return -1;
      if (av > bv) return 1;
      return 0;
    });
  }, [units, maintenanceVehicles]);

  return (
    <Select
      id="vehicles"
      label={messages["vehicleView_vehicles"]}
      value={options.filter((x) => value(x.id))}
      onChange={onChange}
      options={options}
      textField="label"
      valueField="id"
      placeholder={messages["vehicleView_select"]}
      isClearable
      isMulti
      isSearchable
      menuPlacement="top"
    />
  );
};

export default VehicleFilter;
